import React from "react";
import ulStyle from "./files/ulStyle.png";
import styles from "./description.module.css";

class FunctionsTab extends React.Component {
  render() {
    return (
      <div className={styles.functionsTabContainer}>
        <div style={{ fontWeight: "600" }}>ИС «Теплоинформ» обеспечивает:</div>
        <div style={{ fontWeight: "600", paddingTop: "2vh" }}>
          Автоматический сбор данных по настраиваемым расписаниям:
        </div>
        <ul
          style={{
            listStyleImage: "url(" + ulStyle + ")",
            paddingLeft: "1.25em"
          }}
        >
          <li>в определенные дни месяца</li>
          <li>ежедневно</li>
          <li>в определенные часы суток</li>
          <li>периодически</li>
          <li>по требованию оператора</li>
        </ul>
        <div style={{ fontWeight: "600", paddingTop: "2vh" }}>
          На сайте можно получить следующие типы ведомостей в формате Excel:
        </div>
        <ul
          style={{
            listStyleImage: "url(" + ulStyle + ")",
            paddingLeft: "1.25em"
          }}
        >
          <li>по абоненту – посуточная</li>
          <li>по абоненту – почасовая</li>
          <li>по группе абонентов – итоговая за месяц</li>
        </ul>
      </div>
    );
  }
}

export default FunctionsTab;
